<template>
    <VJoyTooltip :text="locationHint" variant="primary">
        <VJoyWrapper no-margin row-gap="1" column-gap="1" wrap="nowrap" align="flex-start">
            <VJoyIcon name="location" />
            <div class="profile-location__text">
                {{ location.city }}
            </div>
        </VJoyWrapper>
    </VJoyTooltip>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyTooltip, VJoyWrapper} from '@maltjoy/core-vue';
    import {useLocationHint} from './useLocationHint';

    const props = defineProps<{
        location: {
            city?: string;
            locationType: string;
        };
        firstName: string;
        targetCity?: string;
    }>();

    const {locationHint} = useLocationHint(props.firstName, props.location, props.targetCity);
</script>

<style scoped lang="scss">
    .profile-location {
        &__text {
            font-weight: var(--joy-font-weight-bold);
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            line-clamp: 1;
            -webkit-line-clamp: 1;
        }
    }
</style>
